import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'review-changes/:url',
  async getComponent (nextState) {
    const {
      default: ReviewChangesContainer
    } = await import(/* webpackChunkName: "review-changes-container" */ './containers/ReviewChangesContainer')
      .catch(handleChunkLoadError);
    return ReviewChangesContainer;
  },
  children: [{
    path: '',
    async getComponent (nextState) {
      const {
        default: ReviewChangesPage
      } = await import(/* webpackChunkName: "review-changes-page" */ './components/ReviewChangesPage')
        .catch(handleChunkLoadError);
      return ReviewChangesPage;
    },
    getData ({ context: { props } }) {
      return props;
    }
  }]
});
